import React, { useState, useEffect } from 'react'
import { createPortal } from 'react-dom'

const Preview = ({ children, width = '100%', height: _ignored, ...rest }) => {
  const [contentRef, setContentRef] = useState(null)
  const [iframeHeight, setIframeHeight] = useState(600)
  const mountNode = contentRef?.contentWindow?.document?.body

  useEffect(() => {
    if (!mountNode) return
    const observer = new ResizeObserver(() => {
      const h = mountNode.scrollHeight
      if (h > 0) setIframeHeight(h)
    })
    observer.observe(mountNode)
    return () => observer.disconnect()
  }, [mountNode])

  return (
    <iframe
      title="preview"
      style={{ border: 0, display: 'block' }}
      {...rest}
      ref={setContentRef}
      width={width}
      height={iframeHeight}
    >
      {mountNode && createPortal(React.Children.only(children), mountNode)}
    </iframe>
  )
}

export default Preview
